<div class="toast-wrapper">
    <div *ngFor="let msg of messages; let i = index" class="message-block">
      <img *ngIf="msg.type == 'success'" [src]="successToasterIcon" alt="success" class="toaster-icon" />
      <img *ngIf="msg.type == 'info'" [src]="neutralToasterIcon" alt="info" class="toaster-icon" />
      <img *ngIf="msg.type == 'error'" [src]="errorToasterIcon" alt="error" class="toaster-icon" />
    
      <div>{{ msg.message }}</div>
      <button class="close-btn" (click)="remove(i)">
        <svg class="close-icon" width="24" height="24" viewBox="0 0 24 24">
          <path d="M6 6L18 18M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </div>
  